import { render, staticRenderFns } from "./miniWXLogin.vue?vue&type=template&id=f1484c5a&scoped=true"
import script from "./miniWXLogin.vue?vue&type=script&lang=js"
export * from "./miniWXLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1484c5a",
  null
  
)

export default component.exports